import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import {
  History,
  ReceiptLong,
  Send,
  SendTwoTone,
  MoreHoriz,
  LocalShipping,
  Create,
  Note,
  Notes,
  NoteAdd,
  NoteAlt,
  LineStyle,
} from "@mui/icons-material";
import DatePicker from "react-datepicker";
import { Delete, Visibility, Download, Store, Add } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchUserProfile } from "../../reducers/userProfileSlice";

function List(props) {
  let vendorType = "";
  const [show, setShow] = useState(false);
  const [currentItem, setCurrentItem] = useState("");
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";
  const [itemList, setItemList] = useState([]);
  const [page, setPage] = useState(1);
  const [filterDateRange, setFilterDateRange] = useState([null, null]);
  const [filterStartDate, filterEndDate] = filterDateRange;
  const [ticketNoOptions, setTicketNoOptions] = useState("");
  const [ticketStatusOptions, setTicketStatusOptions] = useState("");
  const [empNameOptions, setEmpNameOptions] = useState("");

  const dispatch = useDispatch();
  const [showExtendModal, setShowExtendModal] = useState(false);

  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  const [filters, setFilters] = useState({
    searchValue: "",
    empName: "",
    status: "",
    fromDate: "",
    toDate: "",
  });

  const isCFO = utils.hasPermission(
    primaryMenuRes,
    "Technical Support",
    "technical_support.Chief_Financial_Officer_permissions"
  );

  const isTechTeamMember = utils.hasPermission(
    primaryMenuRes,
    "Technical Support",
    "technical_support.Technical_Team_Member_permissions"
  );
  const isRsm = utils.hasPermission(
    primaryMenuRes,
    "Technical Support",
    "technical_support.Regional_Sales_Manager_permissions"
  );
  const isCTO = utils.hasPermission(
    primaryMenuRes,
    "Technical Support",
    "technical_support.Chief_Technology_Officer_permissions"
  );
  // const isTechTeamMember =
  //   userProfile?.user_role[0].roleName === "Technical Team Member";
  // const isRsm = userProfile?.user_role[0].roleName === "Regional Sales Manager";
  // const isCTO = userProfile?.user_role[0].roleName === "CTO";
  // const isCFO =
  //   userProfile?.user_role[0].roleName === "Chief Financial Officer";
  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleActionClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const popoverRef = useRef(null);
  const handleNoted = useCallback((row) => async () => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", row.id);

    if (popoverRef.current) {
      popoverRef.current.click(); // Trigger the overlay to close
    }
    Swal.fire({
      title: "Noted",
      text: "Your request is being processed!",
      icon: "info",
      confirmButtonText: "OK",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/ticket_support_ttm`, bodyFormData)
          .then((res) => {
            if (typeof res !== "undefined") {
              getSupportList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const getActionLinks = (row) => {
    const links = [{ id: "view", name: "View", icon: <Visibility /> }];
    const removeMenu = [];

    if (row.sales_person_id === userProfile.id) {
      if (row.reporting_manager === null) {
        links.push(
          { id: "edit", name: "Edit", icon: <EditIcon /> },
          { id: "delete", name: "Delete", icon: <Delete /> }
        );
      }
    }
    if (isTechTeamMember) {
      removeMenu.push("edit", "delete");
      if (
        utils.hasPermission(
          primaryMenuRes,
          "Technical Support",
          "technical_support.noted"
        )
      ) {
        links.push({ id: "noted", name: "Noted", icon: <NoteAlt /> });

        if (row.technical_team_member_noted === "1") {
          removeMenu.push("noted");
        }
      }
    }

    // if (isTechTeamMember) {
    //   removeMenu.push("edit", "delete");
    //   links.push({ id: "noted", name: "noted", icon: <NoteAlt /> });
    //   if (row.technical_team_member_noted === "1") {
    //     removeMenu.push("noted");
    //   }
    // }

    const myLinks = links.filter((link) => !removeMenu.includes(link.id));

    return myLinks;
  };

  const getActionOnClick = (id, row) => {
    switch (id) {
      case "view":
        handleView(row)();
        break;
      case "edit":
        handelEdit(row)();
        break;
      case "delete":
        showDelete(row)();
      case "noted":
        handleNoted(row)();
        break;
      default:
        break;
    }
  };

  const columns = [
    {
      name: "Ticket No.",
      selector: (row) => row.ticket_number,
      maxWidth: "150px", // Adjust the maximum width as needed
      minWidth: "150px",
    },
    {
      name: "Name",
      selector: (row) => row.sales_person_name,
    },
    {
      name: "Designation",
      selector: (row) => row.designation,
    },
    {
      name: (
        <div>
          Technical
          <br /> Service
        </div>
      ),
      selector: (row) => row.technical_service.length,
      maxWidth: "100px", // Adjust the maximum width as needed
      minWidth: "60px",
      center: true,
    },
    {
      name: "Products",
      selector: (row) => row.products.length,
      maxWidth: "100px", // Adjust the maximum width as needed
      minWidth: "60px",
      center: true,
    },
    {
      name: (
        <div>
          Created
          <br /> Date
        </div>
      ),

      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },

    {
      name: "Action",
      center: true,
      cell: (row) => {
        return (
          <>
            <RB.OverlayTrigger
              trigger="click"
              rootClose
              key="bottom"
              placement="bottom"
              overlay={
                <RB.Popover id={`popover-positioned-bottom`}>
                  <RB.Popover.Body className="p-0">
                    <div className="list-group">
                      {getActionLinks(row).map((link) => (
                        <>
                          <Link
                            to={"#"}
                            className="list-group-item list-group-item-action"
                            onClick={(e) => {
                              e.preventDefault();
                              getActionOnClick(link.id, row);
                            }}
                          >
                            {link.icon} {link.name}
                          </Link>
                        </>
                      ))}
                    </div>
                  </RB.Popover.Body>
                </RB.Popover>
              }
              ref={popoverRef}
            >
              <RB.Button
                className="btn-circle"
                variant="outline-secondary"
                size="sm"
                onClick={() => setShow(!show)}
              >
                <MoreHoriz />
              </RB.Button>
            </RB.OverlayTrigger>
          </>
        );
      },
    },
  ];

  const handleAdd = (row) => {
    setCurrentItem(row);
    setShowExtendModal(true);
  };

  useEffect(() => {
    getSupportList();
  }, [page, userProfile?.id, vendorType]);

  const getSupportList = (filterValues) => {
    filterValues = filterValues ?? "";

    utils
      .callAPI(
        "get",
        `/sales/getsupportList?per_page=${countPerPage}&page=${page}&${filterValues}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setItemList(res);
        } else {
          setItemList([]);
        }
      })
      .catch((err) => {
        setItemList([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleGodown = useCallback((row) => async () => {
    const propdata = {
      mode: "godown",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/getsupportDelete?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              getSupportList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleFilterSearchClick = () => {
    filters.fromDate = filterStartDate
      ? moment(filterStartDate).format("YYYY-MM-DD")
      : "";
    filters.toDate = filterEndDate
      ? moment(filterEndDate).format("YYYY-MM-DD")
      : "";

    const queryParams = new URLSearchParams();
    queryParams.set("ticketNumber", filters.searchValue ?? "");
    queryParams.set("empName", filters.empName ?? "");
    queryParams.set("status", filters.status ?? "");
    queryParams.set("fromDate", filters.fromDate ?? "");
    queryParams.set("toDate", filters.toDate ?? "");

    getSupportList(queryParams.toString());
  };

  const handleFilterResetClick = () => {
    setFilters({
      searchValue: "",
      empName: "",
      status: "",
      fromDate: "",
      toDate: "",
    });

    setFilterDateRange([null, null]);

    const queryParams = new URLSearchParams();

    queryParams.set("searchValue", "");
    queryParams.set("empName", "");
    queryParams.set("status", "");
    queryParams.set("fromDate", "");
    queryParams.set("toDate", "");

    getSupportList(queryParams.toString());
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            {/* {utils.hasPermission(primaryMenuRes, "Quotation", "quotation.create") && ( */}
            {!isTechTeamMember && !isRsm && !isCFO && !isCTO && (
              <RB.Button
                className="btn btn-primary me-2"
                onClick={handleActionClick}
              >
                Create Technical Support
              </RB.Button>
            )}
          </div>
        </RB.Card.Header>

        <RB.CardHeader>
          <RB.Row>
            <RB.Col md={12} className={"border-bottom mb-2"}>
              <h6>Filters</h6>
            </RB.Col>

            <RB.Col md={6}>
              <RB.Form.Label>Search by Ticket Number</RB.Form.Label>

              <RB.Form.Control
                type={"text"}
                name={"searchValue"}
                value={filters.searchValue}
                onChange={handleFilterChange}
                style={{ height: "auto" }}
              />
            </RB.Col>

            <RB.Col md={6}>
              <RB.Form.Label>Name</RB.Form.Label>
              <RB.Form.Control
                type={"text"}
                name={"empName"}
                value={filters.empName}
                onChange={handleFilterChange}
                style={{ height: "auto" }}
              />
            </RB.Col>

            <RB.Col>
              <RB.FormGroup className="mb-3">
                <RB.Form.Label>Ticket Status</RB.Form.Label>
                <RB.Form.Select
                  name="status"
                  className="form-control"
                  onChange={handleFilterChange}
                  value={filters.status}
                >
                  <option value="">Select Ticket Status</option>
                  <option value="In Process">In Process</option>
                  <option value="Rejected">Rejected</option>
                  <option value="Closed">Closed</option>
                </RB.Form.Select>
              </RB.FormGroup>
            </RB.Col>

            <RB.Col>
              <RB.FormGroup className="mb-3">
                <RB.Form.Label>Date</RB.Form.Label>
                <DatePicker
                  selectsRange={true}
                  dateFormat="dd/MM/yyyy"
                  startDate={filterStartDate}
                  endDate={filterEndDate}
                  onChange={(update) => {
                    /*setFilters({
                        ...filters,
                        fromDate: filterStartDate,
                        toDate: filterEndDate
                      })*/
                    setFilterDateRange(update);
                  }}
                  value={filterDateRange}
                  className="form-control form-control-auto"
                />
              </RB.FormGroup>
            </RB.Col>

            <RB.Col className={"d-flex align-items-end"}>
              <RB.FormGroup className="mb-3">
                <RB.Form.Label>&nbsp;</RB.Form.Label>
                <RB.Button
                  variant="primary"
                  type="button"
                  onClick={handleFilterSearchClick}
                >
                  Submit
                </RB.Button>
                <RB.Button
                  variant="light"
                  type="button"
                  className={"ms-1"}
                  onClick={handleFilterResetClick}
                >
                  Reset
                </RB.Button>
              </RB.FormGroup>
            </RB.Col>
          </RB.Row>
        </RB.CardHeader>

        <RB.Card.Body>
          {utils.hasPermission(
            primaryMenuRes,
            "Technical Support",
            "technical_support.view"
          ) && (
            <DataTable
              columns={columns}
              data={itemList.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={itemList.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              conditionalRowStyles={[
                {
                  when: (row) => row.status === "Rejected",
                  style: {
                    backgroundColor: "#ffe6e6", // Light red color
                  },
                },
                {
                  when: (row) => row.status === "Closed",
                  style: {
                    backgroundColor: "#e6ffe6", // Light green color
                  },
                },
              ]}
            />
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
